import {put,takeEvery} from 'redux-saga/dist/redux-saga-effects-npm-proxy.esm';

import {TYPES as MEDIA_TYPE} from '../creators/media';

export function* createSuccess(action) {
    try {
        yield put({type: "MEDIAS_ADD", data : action.payload});
        yield put({type: "ALBUM_MEDIAS_ADD", data : action.payload});
        //yield put({type: "USER_ALBUMS_ADD_MEDIA", data : action.payload});

    } catch (error) {

    }
}

export function* deleteSuccess(action) {
    try {
        yield put({type: "MEDIAS_DELETE", data : action.payload});
        yield put({type: "ALBUM_MEDIAS_DELETE", data : action.payload});
        yield put({type: "ALBUM_MEDIAS_MULTI_DELETE", data : action.payload});
        yield put({type: "USER_ALBUMS_DELETE_MEDIA", data : action.payload});
        yield put({type: "USER_MEDIAS_DELETE", data : action.payload});
    } catch (error) {

    }
}

export function* updateSuccess(action) {
    try {
        yield put({type: "MEDIAS_UPDATE", data : action.payload});
        yield put({type: "USER_MEDIAS_UPDATE", data : action.payload});
        yield put({type: "ALBUM_MEDIAS_UPDATE", data : action.payload});
        yield put({type: "ALBUM_MEDIAS_MULTI_UPDATE", data : action.payload});
    } catch (error) {

    }
}


export function* watchMedia() {
    yield takeEvery(MEDIA_TYPE.CREATE_SUCCESS, createSuccess);
    yield takeEvery(MEDIA_TYPE.DELETE_SUCCESS, deleteSuccess);
    yield takeEvery(MEDIA_TYPE.UPDATE_SUCCESS, updateSuccess);
}

export default watchMedia;

